import React from "react";
import "./Hero.scss";
import PrimaryButton from "../../../../common/primaryButton";
import { headerVideo } from "../../../../assets/videos/videos";

const Hero = () => {
  return (
    <section className="section hero-section">
      <div className="container">
        <div className="hero-content" data-aos="fade-down">
          <h5>Life's Potential Begins Here</h5>
          <h2>Pioneering the future of genetic innovation</h2>
          <PrimaryButton
            primaryBtnText="Get Started"
            primaryExternalLink={"https://portal.gattacagenomics.com/"}
          />
        </div>
      </div>
      <div className="video-wrapper">
        <video autoPlay muted loop playsInline data-aos="fade-up">
          <source src={headerVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="hero-card">
        <div className="heading">
          <span>New!</span>
          <h4>Approved for clinical trials!</h4>
        </div>
        <p>
          Gattaca has received approval for a landmark study to enhance embryo
          selection using deep learning.
        </p>
      </div>
    </section>
  );
};

export default Hero;
